export default __webpack_public_path__ + "img/ca3b383203145616494526e99a7723df.svg";